import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiRespuesta, ApiRespuestaPaginada } from '@app/models/ApiRespuesta.interface';
import { TipoPlanilla } from '@app/models/tipo-planilla';
import { catchError, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { handleError } from '../tools/handle-error';

@Injectable({ providedIn: 'root' })
export class TipoPlanillaService {
  private readonly url = environment.url + 'rh-form';
  private readonly http = inject(HttpClient);
  private readonly aprobacionUrl = environment.url + 'aprobacion/tipo-planilla';

  create(payload: Partial<TipoPlanilla>): Observable<TipoPlanilla> {
    return this.http.post<ApiRespuesta<TipoPlanilla>>(this.url, payload).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result)
    );
  }

  // Obtener tipos de planilla de aprobación (catálogo) - soporta modulo o moduloId

  // Obtener todos los tipos de planilla con paginación opcional
  getAll(params?: HttpParams): Observable<{ entities: TipoPlanilla[]; count: number }> {
    const direction = `${this.url}/get/all`;
    return this.http
      .get<ApiRespuestaPaginada<TipoPlanilla>>(direction, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result)
      );
  }

  // Actualizar un tipo de planilla
  update(payload: Partial<TipoPlanilla>): Observable<TipoPlanilla> {
    const direction = `${this.url}/${payload.id}`;
    return this.http.put<ApiRespuesta<TipoPlanilla>>(direction, payload).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result)
    );
  }

  // Aprobación: obtener tipos de planilla filtrados por módulo (id o nombre)
  getAprobacionTipos(opts?: { modulo?: string; moduloId?: string }) {
    const base = environment.url + 'aprobacion/tipo-planilla/get/all';
    let params = new HttpParams();
    if (opts?.modulo) params = params.set('modulo', opts.modulo);
    if (opts?.moduloId) params = params.set('moduloId', opts.moduloId);
    return this.http
      .get<ApiRespuestaPaginada<any>>(base, { params })
      .pipe(catchError((err) => handleError(err)), map((res) => res.result));
  }
}
